import React from 'react'

const Zwop = ({}) => {

    const a: number = 1
    const b: boolean = true

    return (
        <div
            style={{
                color: '#a94939',
                position: 'absolute',
                top: 300,
                left: 300,
            }}
        >{}</div>
    )
}

export default Zwop